import { useMemo, useState } from "react";

export const usePaginationData = <T>({
  data,
  piecesPerPage,
  initialPage = 1,
}: {
  data: T[];
  piecesPerPage: number;
  initialPage: number;
}) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const numberOfPages = Math.ceil(data.length / piecesPerPage);

  const setCurrentPageWithCheck = (newPage: number) => {
    if (newPage < 1) {
      setCurrentPage(1);
    } else if (newPage > numberOfPages) {
      setCurrentPage(numberOfPages);
    } else {
      setCurrentPage(newPage);
    }
  };

  const paginatedData = useMemo(() => {
    const endIndex = currentPage * piecesPerPage;
    const startIndex = endIndex - piecesPerPage;
    return data.slice(startIndex, endIndex);
  }, [currentPage, data, piecesPerPage]);

  return { currentPage, setCurrentPageWithCheck, numberOfPages, paginatedData };
};
